import {useEffect} from "react";

import {AssetListItemData} from "../../../../asset/util/assetModels";
import useAsyncProcess from "../../../../core/network/async-process/useAsyncProcess";
import {useWalletContext} from "../../../../wallet/util/context/WalletContext.utils";
import assetApi from "../../../../asset/api/assetApi";
import {getSelectableAssetsFromSearchParams} from "../../../../core/widgetUtils";

interface UseSearchPoolMemberAssetsOptions {
  keyword: string;
  limit?: number;
  assetsToFilterOut?: string[];
}

function useSearchPoolMemberAssets({
  keyword,
  limit,
  assetsToFilterOut
}: UseSearchPoolMemberAssetsOptions) {
  const {state, runAsyncProcess} =
    useAsyncProcess<ListRequestResponse<AssetListItemData>>();
  const {account, accountAssets} = useWalletContext();
  const selectableAssets = getSelectableAssetsFromSearchParams();

  // joined the array together as string to avoid passing the array as dependency to useEffect
  const assetsToFilterOut_string = (assetsToFilterOut || []).join(",");

  useEffect(() => {
    runAsyncProcess(
      assetApi
        .listSwapAssets(
          {
            is_pool_member: true,
            search: keyword,
            limit: limit ?? "all",
            ids: selectableAssets
          },
          account,
          accountAssets
        )
        .then((data) => {
          const assetIdsToFilterOut = new Set(assetsToFilterOut_string?.split(",") || []);

          return {
            ...data,
            results: assetIdsToFilterOut.size
              ? data.results.filter((item) => !assetIdsToFilterOut.has(item.id))
              : data.results
          };
        })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, accountAssets, runAsyncProcess, keyword, limit, assetsToFilterOut_string]);

  return state;
}

export default useSearchPoolMemberAssets;
